import type { AccessResourceType } from '~/features/access-control/types/AccessControl';

import { getMockResourceAccess } from '~/features/access-control/mocks/accessControlMockStore';
import { withAccessControlMockFallback } from '~/features/access-control/mocks/withAccessControlMockFallback';
import { pilot } from '~/services/serviceInstances';

import type { ResourceAccess, ServerResourceAccess } from './accessGrantMapper';

import { mapResourceAccessResponse } from './accessGrantMapper';

type Request = {
  resourceId: string;
  resourceType: AccessResourceType;
};

export const getResourceAccess = async ({
  resourceId,
  resourceType,
}: Request): Promise<ResourceAccess> => {
  return withAccessControlMockFallback(
    async () => {
      const serverResponse = await pilot.get<ServerResourceAccess>(
        '/access/resource/',
        { params: { resource_id: resourceId, resource_type: resourceType } },
      );

      return mapResourceAccessResponse(serverResponse);
    },
    () => getMockResourceAccess(resourceType, resourceId),
  );
};
